/**
 * Узнаваемость личности для туриста без локальной истории.
 * world — household name (Моцарт, Кафка); local — всё остальное.
 * При сомнении всегда local.
 */
export enum PersonRecognitionEnum {
    WORLD = 'world',
    LOCAL = 'local',
}
